<template lang='pug'>
  ul#user-menu(v-if='!showAdminNav')
    li.nav-item.no-dropdown
      router-link.nav-title(:to='{ name: "product-groups-show", params: { id: "new-arrivals" } }' v-text='$t("products.productGroup.newArrivals")' @click.native='resetActiveSubmenu')

    li.nav-item.categories-menu.tablet(:class='{ "hide-dropdown": activeSubmenu !== "categories" }')
      a.nav-title(v-text='$t("products.category.title")' @click='setActiveSubmenu("categories")')
      .nav-pane
        .nav-menu-container
          ul.nav-menu(v-for='topLevelCategory in topLevelCategories')
            li.menu-item
              router-link.h4.menu-sub-title(:to='categoryPath(topLevelCategory)' @click.native='resetActiveSubmenu' v-text='topLevelCategory.attributes.label')
              span.sub-title-arrow

            li.menu-item(v-if='topLevelCategory.attributes["slug-url"] === "clean"')
              router-link.item-link(:to='CLEAN_AT_SEPHORA_LINK' @click.native='resetActiveSubmenu' v-text='$t("navigation.links.cleanAtSephora")')

            li.menu-item(v-for='secondLevelCategory in childCategoriesFor(topLevelCategory)')
              router-link.item-link(:to='categoryPath(secondLevelCategory)' @click.native='resetActiveSubmenu' v-text='secondLevelCategory.attributes.label')

    li.nav-item.categories-menu.desktop(:class='{ "hide-dropdown": activeSubmenu !== "categories" }' v-for='(topLevelCategory, index) in topLevelCategories')
      router-link.nav-title(:to='categoryPath(topLevelCategory)' @click.native='resetActiveSubmenu' @mouseenter.native='adjustNavPane($event.target, "categories")' @mouseleave='resetActiveSubmenu' v-text='topLevelCategory.attributes.label')
      .nav-pane
        .nav-menu-container
          ul.nav-menu(v-if='topLevelCategory.attributes["slug-url"] === "gifts" && supportGiftCard')
            li.menu-item
              a.h4.menu-sub-title(:href='"/gift-cards"' v-text='$t("navigation.links.giftCards")' rel='noopener' target='_blank')
              span.sub-title-arrow

          ul.nav-menu(v-if='topLevelCategory.attributes["slug-url"] === "clean"')
            li.menu-item
              a.h4.menu-sub-title(:href='CLEAN_AT_SEPHORA_LINK' v-text='$t("navigation.links.cleanAtSephora")' rel='noopener')
              span.sub-title-arrow

          ul.nav-menu(v-for='secondLevelCategory in childCategoriesFor(topLevelCategory)')
            li.menu-item
              router-link.h4.menu-sub-title(:to='categoryPath(secondLevelCategory)' @click.native='resetActiveSubmenu' v-text='secondLevelCategory.attributes.label')
              span.sub-title-arrow
            li.menu-item(v-for='thirdLevelCategory in childCategoriesFor(secondLevelCategory)')
              router-link.item-link(:to='categoryPath(thirdLevelCategory)' @click.native='resetActiveSubmenu' v-text='thirdLevelCategory.attributes.label')

          template(v-if='customNavMenu[index]')
            .custom-nav-menu
              ul.nav-menu
                span.h4.menu-sub-title(v-text='customNavMenu[index].details["1"].title')
                li.menu-item(v-for='link in customNavMenu[index].details["1"].links')
                  a.item-link(:href='link.url' v-text='link.name')
              .custom-nav-menu-banner(v-if='customNavMenu[index].image')

                template(v-if='customNavMenu[index]["image_link"]')
                  a(:href='customNavMenu[index]["image_link"]')
                    img.banner-image(:src='customNavMenu[index]["image_url"]')
                  a.image-title(:href='customNavMenu[index]["image_link"]' v-text='customNavMenu[index]["image_title"]')

    li.nav-item.brands-menu(:class='{ "hide-dropdown": activeSubmenu !== "brands" }')
      router-link.nav-title.desktop(:to='{ name: "brands-index" }' v-text='$t("products.brand.title")' @mouseenter.native='adjustNavPane($event.target, "brands")' @mouseleave='resetActiveSubmenu' @click.native='resetActiveSubmenu')
      a.nav-title.tablet(v-text='$t("products.brand.title")' @click='setActiveSubmenu("brands")')
      .nav-pane.brands
        .nav-menu
          .brands-search
            router-link.h4.menu-sub-title(:to='{ name: "brands-show", params: { id: sephoraCollection }}' @click.native='resetActiveSubmenu' v-text='$t("products.brand.shopSephoraCollection")')
            form.search-form
              .form-group.floating-labels
                label.control-label(for='search-brand' v-text='$t("navigation.common.search")')
                input#search-brand.form-control(v-model='displayBrandSearch' type='text')
              ul.letter-list
                li.menu-item(v-for='letter in allLetters')
                  a.h4.letter-link(
                    :class='{ "disabled": displayBrands(letter.currentLangLetter).length === 0 }' @click.prevent='searchBrandsByLetter(letter.enLetter, $event)' v-text='letter.currentLangLetter'
                  )

          ul#brands-anchor.brands-list
            li.menu-item
              router-link.h4.tablet.menu-sub-title(:to='{ name: "brands-index" }' v-text='$t("products.brand.allBrands")')

            template(v-if='!brandsLoaded')
              .brands-spinner-container
                .loader-spinner

            template(v-else)
              li(v-for='letter in allLetters'  v-if='displayBrands(letter.currentLangLetter).length > 0')
                span.h4.menu-sub-title(:id='`#brand-letter-${letter.enLetter}`' v-text='letter.currentLangLetter')
                ul
                  li.menu-item(v-for='brand in displayBrands(letter.currentLangLetter)')
                    router-link.item-link(:to='{ name: "brands-show", params: { id: brand.attributes["slug-url"] }}' @click.native='resetActiveSubmenu' v-text='brand.attributes["name"]')

    li.nav-item.sale-menu(:class='{ "hide-dropdown": activeSubmenu !== "sale" }' v-if='!hideSales')
      router-link.nav-title.desktop(:to='salePath()' @click.native='resetActiveSubmenu' @mouseenter.native='adjustNavPane($event.target, "sale")' @mouseleave='resetActiveSubmenu' v-text='$t("products.landingPage.sale")')
      a.nav-title.tablet(v-text='$t("products.landingPage.sale")' @click='setActiveSubmenu("sale")')
      .nav-pane.sale
        ul.nav-menu
          li.menu-item
            span.h4.desktop.menu-sub-title(v-text='$t("products.landingPage.sale")')
            router-link.h4.tablet.menu-sub-title(:to='{ name: "landing-pages-sale" }' @click.native='resetActiveSubmenu' v-text='$t("products.landingPage.sale")')
          li.menu-item(v-for='topLevelCategory in topLevelCategories')
            router-link.item-link(:to='salePath(topLevelCategory)' @click.native='resetActiveSubmenu' v-text='topLevelCategory.attributes.label')

    navigation-json-seo-schema
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { disassemble } from 'hangul-js'
import NavigationJsonSeoSchema from './navigation-json-seo-schema.vue'
import { categoryUtil, saleUtil } from '@/mixins/pathUtil'
import { brandUtil } from '@/mixins/brandUtil'
import { localeIsKR, allLetters } from '@/modules/services/lettersForLanguage'

export default {
  components: {
    NavigationJsonSeoSchema
  },

  mixins: [
    brandUtil,
    categoryUtil,
    saleUtil
  ],

  data () {
    return {
      displayBrandSearch: null,
      isSearchingBrands: false,
      activeSubmenu: null, // to close sub menu after navigation
      sephoraCollection: 'sephora-collection',
      CLEAN_AT_SEPHORA_LINK: '/pages/clean-at-sephora'
    }
  },

  computed: {
    ...mapState({
      currentUser: state => state.user.currentUser,
      showAdminNav: state => state.layout.showAdminNav,
      allBrands: state => state.brands.allBrands,
      brandsLoaded: state => state.brands.brandsLoaded
    }),
    ...mapGetters([
      'childCategoriesFor',
      'topLevelCategories',
      'showSubcategoriesFor',
      'brandsStartingWithInitialChar',
      'brandsStartingWithNumber'
    ]),
    hideSales: () => vueSupport.header.hideSales,
    customNavMenu: () => vueSupport.header.customNavMenu,
    supportGiftCard: () => vueSupport.header.supportGiftCard,
    allLetters: () => allLetters()
  },

  methods: {
    adjustNavPane (target, navName) {
      const navbar = document.getElementById('user-menu')
      const parent = target.parentNode
      const dropdown = parent.querySelector('.nav-pane')

      this.setActiveSubmenu(navName)

      if (navName === 'brands' && !this.brandsLoaded) {
        this.$store.dispatch('fetchBrands')
      }

      if (dropdown.scrollWidth > dropdown.offsetWidth && navName !== 'brands') {
        dropdown.style.width = `${dropdown.scrollWidth + 50}px`
      }

      if (dropdown.getBoundingClientRect().left + dropdown.offsetWidth > navbar.getBoundingClientRect().left + navbar.offsetWidth) {
        dropdown.style.right = '-1px'
      }
    },

    displayBrands (letter) {
      let brands = []
      const initialChar = 'a'

      if (localeIsKR()) {
        // ex. '가' -> 'ㄱ'
        letter = disassemble(letter)[0]
        brands = this.brandsStartingWithInitialChar(letter)
      } else if (letter.toLowerCase() === initialChar) {
        brands = this.brandsStartingWithNumber.concat(this.brandsStartingWithInitialChar(letter))
      } else {
        brands = this.brandsStartingWithInitialChar(letter)
      }

      if (this.displayBrandSearch) {
        this.isSearchingBrands = true

        return brands.filter(
          brand => this.normalizeAccentedBrandName(brand.attributes.name).includes(
            this.normalizeAccentedBrandName(this.displayBrandSearch)
          )
        )
      } else {
        this.isSearchingBrands = false

        return brands
      }
    },

    searchBrandsByLetter (letter, event) {
      const offset = document.getElementById(`#brand-letter-${letter}`).offsetTop

      this.$scrollTo(`#brands-anchor`, 200, {
        container: '.brands-list',
        offset
      })
    },

    setActiveSubmenu (navName) {
      this.activeSubmenu = navName
    },

    resetActiveSubmenu () {
      this.activeSubmenu = null
    }
  }
}
</script>

<style lang='scss' scoped>
  #user-menu {
    display: flex;
    justify-content: space-between;
    position: relative;

    .nav-title {
      @include font-weight-bold;
      display: inline-block;
      font-size: 13px;
      color: $black;
      text-transform: uppercase;
      padding: 10px 20px 8px;
      position: relative;
      z-index: 2;

      &.tablet {
        display: inline-block;

        @include media-breakpoint-up(xl) {
          display: none;
        }
      }

      &.desktop {
        display: none;

        @include media-breakpoint-up(xl) {
          display: inline-block;
        }
      }

      &:lang(vi) {
        white-space: nowrap;
      }
    }

    .nav-item {
      &:hover:not(.hide-dropdown) {
        .nav-title {
          color: $brand-primary;
        }
      }

      &.tablet {
        display: inline-block;

        @include media-breakpoint-up(xl) {
          display: none;
        }
      }

      &.desktop {
        display: none;

        @include media-breakpoint-up(xl) {
          display: inline-block;
        }
      }

      &:first-child .nav-title {
        padding-left: 5px;
      }

      &:last-child .nav-title {
        padding-right: 5px;
      }

      &:hover:not(.no-dropdown):not(.hide-dropdown) {
        height: 33px;
        background: $white;
        box-shadow: 0 1px 10px 0 $grey;

        &:hover::after {
          background: $white;
          content: '';
          display: block;
          position: relative;
          top: -8px;
          height: 10px;
          width: 100%;
        }

        .nav-pane {
          visibility: visible;
          opacity: 1;
          box-sizing: border-box;
          width: 100%;

          @include media-breakpoint-up(xl) {
            width: auto;
          }
        }
      }

      &.no-dropdown {
        box-shadow: none;

        &:hover {
          background: none;
          border-color: $white;
          box-shadow: none;
          border-right: 0;
        }
      }

      .nav-pane {
        visibility: hidden;
        cursor: default;
        position: absolute;
        top: 35px;
        background-color: $white;
        padding: 20px 20px 20px 5px;
        opacity: 0;
        left: 0;
        right: 0;
        box-shadow: 0 1px 10px 0 $grey;
        display: flex;

        @include media-breakpoint-up(xl) {
          left: auto;
          right: auto;
        }

        &:not(.brands) {
          max-height: 465px;
          overflow-x: auto;
          width: 160px;
          white-space: nowrap;

          @include media-breakpoint-up(lg) {
            max-height: 360px;
          }
        }

        .menu-item {
          &:first-child {
            margin-bottom: 3px;
          }
        }

        .menu-sub-title {
          @include font-weight-bold;
          font-size: 13px;
          text-transform: uppercase;
          letter-spacing: 1px;
          display: inline;
          margin-right: 5px;

          &.tablet {
            display: inline-block;

            @include media-breakpoint-up(xl) {
              display: none;
            }
          }

          &.desktop {
            display: none;

            @include media-breakpoint-up(xl) {
              display: inline-block;
              color: $brand-primary;
            }
          }
        }

        .nav-menu-container {
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;
          width: 100%;
          height: auto;

          .nav-menu {
            box-sizing: content-box;
            display: inline-block;
            margin-bottom: 20px;
            width: auto;
            margin-left: 15px;
          }
        }

        .custom-nav-menu {
          border-left: 1px solid $grey;
          min-height: 300px;
          display: inline-block;
          min-width: 160px;
          padding: 0 0 0 5px;
          margin-left: 20px;

          .banner-image {
            width: 140px;
            height: 100px;
            vertical-align: bottom;
          }

          .image-title {
            @include font-weight-bold;
            font-size: 13px;
            letter-spacing: 1px;
            text-transform: uppercase;
          }

          .custom-nav-menu-banner {
            position: absolute;
            bottom: 20px;
          }
        }

        .item-link {
          @include font-weight-book;
          text-align: left;
          line-height: 24px;
        }

        &.sale {
          padding-left: 20px;
        }

        &.brands {
          width: 100%;
          max-height: 340px;
          overflow-y: hidden;
          padding-left: 20px;

          @include media-breakpoint-up(xl) {
            width: auto;
          }

          .nav-menu {
            margin: 0 auto;
            position: relative;
            left: 0;
            right: 0;

            @include media-breakpoint-up(xl) {
              width: max-content;
              max-height: 300px;
            }
          }

          .brands-list {
            height: 300px;
            width: 240px;
            border-left: 1px solid $grey;
            overflow-y: scroll;
            padding-left: 20px;
            display: inline-block;

            .brands-spinner-container {
              display: flex;
              justify-content: center;
              align-items: center;
              min-height: 245px;
            }

            &::-webkit-scrollbar {
              width: 6px;
              height: 20px;
              background-color: #dbdbdb;
            }

            &::-webkit-scrollbar-thumb {
              background-color: $black;
            }
          }

          .brands-search {
            display: inline-block;
            vertical-align: top;

            .menu-sub-title {
              margin-left: 1px;
            }

            .search-form {
              @include font-weight-book;
            }

            #search-brand {
              width: 225px;
            }

            .letter-list {
              padding: 0;
              text-align: left;
              width: 240px;

              .menu-item {
                display: inline-block;
                vertical-align: top;
                margin-left: 5px;
                width: 29px;
                height: 40px;

                .letter-link {
                  display: block;
                  @include font-weight-bold;
                  font-size: 16px;
                  text-transform: uppercase;

                  &.disabled {
                    pointer-events: none;
                    color: $grey;

                    &:hover {
                      color: $grey;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .sub-title-arrow {
      border-top: 4px solid transparent;
      border-bottom: 4px solid transparent;
      border-left: 4px solid $brand-primary;
      display: inline-block;
    }
  }
</style>
